export default __webpack_public_path__ + "static/media/kaggle.3bfe31fc.png";